import { Component, computed, DestroyRef, inject, input, OnInit, signal } from '@angular/core'
import { SidebarAction, SidebarService } from '../sidebar/sidebar.service'
import { Subscription } from 'rxjs'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
    selector: 'sf-sidebar-starter',
    imports: [],
    template: `<ng-content></ng-content>`,
    host: {
        class: 'sidebar-starter',
        '[class]': 'hostClasses()',
    },
})
export class SidebarStarterComponent implements OnInit {
    readonly #sidebarService = inject(SidebarService)
    readonly #destroyRef = inject(DestroyRef)

    readonly id = input<string>()

    readonly #visible = signal<boolean>(true)

    readonly state = signal<SidebarAction>({ visible: true })

    set sidebarState(value: SidebarAction) {
        const newState = value
        if ('toggle' in newState) {
            if (newState.toggle === 'visible') {
                newState.visible = !this.#visible()
                this.#visible.set(newState.visible)
            }
        } else {
            this.#visible.set(!!newState.visible)
        }

        this.state.update((state) => ({ ...state, ...newState }))
    }

    get sidebarState(): SidebarAction {
        return { ...this.state() }
    }

    ngOnInit(): void {
        this.#sidebarService.sidebarState$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((state) => {
            this.sidebarState = { ...state }
        })
    }

    readonly hostClasses = computed(() => {
        const { mobile, visible } = { ...this.sidebarState }
        return {
            show: visible,
            hide: !visible,
        }
    })
}
